import { render, staticRenderFns } from "./IconResults.vue?vue&type=template&id=3a7c165e"
import script from "./IconResults.vue?vue&type=script&lang=js"
export * from "./IconResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports